import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { TDR } from 'tdr-common';
import { analytics } from '../../../helpers/analytics';
import { buildExploreHref } from '../../../helpers/buildExploreHref';
import { resolveLocalizedText } from '../../../helpers/resolveLocalizedText';
import { NoticeTile, NoticeTileIcon } from '../../notice-cards/NoticeTile';

const ICON_MAP: Record<TDR.SearchConfig.InboundIcon, NoticeTileIcon> = {
	star: 'event',
	people: 'cross-sell'
};

export type InboundTablzRestaurantSectionProps = {
	section: TDR.SearchConfig.InboundTablzRestaurantSection;
	restaurant: TDR.Restaurant;
};

export function InboundTablzRestaurantSection({ section, restaurant }: InboundTablzRestaurantSectionProps) {
	const { i18n } = useTranslation();
	const location = useLocation();

	// Configured entirely via settings.searchConfig — the legacy
	// largeGroupInbounds feature flag no longer feeds the results page.
	const slug = section.slug;
	const title = section.header;
	const body = section.body;

	useEffect(() => {
		if (!slug) {
			return;
		}
		analytics.track('Notice Viewed', {
			notice: 'InboundTablzRestaurantSection',
			restaurantId: restaurant?.id,
			sisterRestaurantSlug: slug
		});
	}, [restaurant?.id, slug]);

	if (!slug || !title) {
		return null;
	}

	return (
		<section className='px-5 pt-6 sm:px-0 sm:pt-4'>
			<NoticeTile
				icon={ICON_MAP[section.icon ?? 'people']}
				title={resolveLocalizedText(title, i18n.language)}
				subtitle={body ? resolveLocalizedText(body, i18n.language) : ''}
				href={buildExploreHref(slug, location.search)}
				onClick={() => analytics.track('Cross Sell Card Clicked', {
					source: 'search_config_section',
					restaurantId: restaurant?.id,
					sisterRestaurantSlug: slug
				})}
				data-cy='inbound-tablz-restaurant-card'
			/>
		</section>
	);
}
